import { Bar } from "react-chartjs-2";

const TimeOnlineChart = ({ data }) => {
    // Preparar los datos para Chart.js
    const currentTimeInSeconds = Math.floor(Date.now() / 1000);

    const getHappyColor = () => {
        const randomHue = Math.random() * 360; // Tonos de 0 a 360 grados
        //const saturation = 46; // Saturación
        const saturation = 65; // Saturación
        //const lightness = 58; // Brillo
        const lightness = 65; // Brillo
        return `hsla(${randomHue}, ${saturation}%, ${lightness}%, 0.8)`;
    };

    const formatTime = (seconds) => {
        if (seconds === 0) {
            return '0s';
        }
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const sec = seconds % 60;
        return `${hours}h, ${minutes}m, ${sec}s`;
    };


    // Encontrar el valor máximo y mínimo para la escala de colores
    const maxTime = Math.max(...data.map(item => currentTimeInSeconds - item.time));
    const minTime = Math.min(...data.map(item => currentTimeInSeconds - item.time));



    //const randomColors = Array.from({ length: data.length }, () => `rgba(${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, 0.4)`);
    const randomColors = Array.from({ length: data.length }, getHappyColor);

    const chartData = {
        labels: data.map(item => item.name),
        datasets: [
            {
                categoryPercentage: 1,
                barPercentage: 0.4,
                //barThickness: 10,
                //maxBarThickness: 20,
                minBarLength: 10,
                label: 'Tiempo online',
                data: data.map(item => currentTimeInSeconds - item.time),
                //backgroundColor: 'rgba(75,192,192,0.4)', // Color de fondo de las barras
                //borderColor: 'rgba(75,192,192,1)', // Color del borde de las barras
                backgroundColor: randomColors,
                borderColor: randomColors.map(color => color.replace('0.4', '1')), // Establecer el borde con opacidad completa
                //backgroundColor: data.map(item => getRedToGreenColor(currentTimeInSeconds - item.time, minTime, maxTime)),
                //borderColor: data.map(item => getRedToGreenColor(currentTimeInSeconds - item.time, minTime, maxTime)),
                borderWidth: 1,
            },
        ],
    };

    // Configuración de la gráfica
    // Configuración de la gráfica
    const chartOptions = {
        type: 'line',
        responsive: true,
        maintainAspectRatio: true,
        //aspectRatio: 0.18,
        aspectRatio: 1,
        indexAxis: 'y',
        scales: {
            x: {
                title: {
                    type: 'time',
                    display: true,
                    text: 'Tiempo'
                },
                ticks: {
                    stepSize: 3600,
                    font: {
                        size: 12
                    },
                    // Include a dollar sign in the ticks
                    callback: function (value, index, ticks) {
                        return formatTime(value);
                        //return value;
                    }
                }
            },
            y: {
                title: {
                    display: true,
                    text: 'Fuentes',
                },
                ticks: {
                    stepSize: 1,
                    font: {
                        size: 11
                    },
                }
            },
        },
        plugins: {
            datalabels: {
                display: function (context) {
                    return false
                }
            },
            tooltip: {
                callbacks: {
                    label: (tooltipItem) => formatTime(tooltipItem.raw),
                    //label: (tooltipItem) => tooltipItem.raw,
                },
            },
            title: {
                display: true,
                text: 'Tiempo de ejecución',
                font: {
                    size: 18
                }
            }
        }
    };

    return (

        <Bar data={chartData} options={chartOptions} className="mt-5" />

    );
};

export default TimeOnlineChart